// extracted by mini-css-extract-plugin
module.exports = {"pVideoBackground":"r_bj","pVideoBackground__overlay":"r_bk","pVideoBackground__inner":"r_bl","animationMarquee":"r_j"};